import noAuthApiClient from '../noAuthApiClient';
export const getProducts = () => {
  return noAuthApiClient.get('/monetization/v3/product');
};